import httpManager from "@/app/shared/utils/httpManager";

export async function fetchMessagesWaitingByQueue(queueId) {
  const url = `/queues/${queueId}/messages/`;
  const response = await httpManager.get(url);
  return response.data?.messages;
}
